import axios from "../../../common/config/axios";
import * as type from "./types";

export const getList = (data) => (dispatch, getState) => {
    data.country_id = getState().currentUser.data.country_id;
    axios.get("voucher_claim/list", {
            params: data,
        }).then((res) => {
            dispatch({
                type: type.LIST,
                payload: res,
            });
        }).catch((err) => {
            // dispatch({
            //     type: type.LIST,
            //     payload: [],
            // });
        });
};